import { Box, Grid, Typography, Button } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

import {
  PhoneIcon,
  MobileIcon,
  EmailIcon,
  HelpQuestionIcon,
} from '../../theme/styled-components';

interface SaltusOwnerItem {
  SaltusOwnerType: string;
  FirstName: string;
  LastName: string;
  PrimaryEmail?: string;
  MobilePhone?: string;
  WorkPhone?: string;
  [key: string]: unknown;
}

interface TeamMemberInfoItem {
  Title: string;
  Image?: string;
  [key: string]: unknown;
}

interface Props {
  classes: Record<string, string>;
  saltusowners: { items?: SaltusOwnerItem[] };
  teammemberinfo: { items?: TeamMemberInfoItem[] };
}

function HelpCard({
  classes = {},
  saltusowners = {},
  teammemberinfo = {},
}: Props) {
  const saltusowner = (saltusowners?.items ?? []).find(
    (item) => item.SaltusOwnerType === 'Owner',
  );
  if (!saltusowner) {
    return <span />;
  }

  const saltusownerinfo = saltusowner
    ? (teammemberinfo?.items ?? []).find(
        (item) =>
          (item?.Title ?? '') ===
          `${saltusowner.FirstName} ${saltusowner.LastName}`,
      )
    : null;

  if (!saltusowners && !teammemberinfo) return <span />;

  return (
    <Box className={classes.root}>
      <Box className={classes.content}>
        <Box className={classes.helpTitleContainer}>
          <HelpQuestionIcon />
          <Typography className={classes.helpTitle} variant="body2">
            Need some help?
          </Typography>
        </Box>
        <Grid
          container
          justifyContent="center"
          className={classes.helpContainer}
        >
          <Grid item xs={12}>
            <Box mb={5}>
              <Typography
                className={classes.helpContent}
                color="inherit"
                variant="body2"
              >
                If you would like to speak to someone before authorising this
                document then you can contact your relationship manager or book
                an appointment for later.
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box className={classes.helpContentGrid}>
              <Box
                className={`${classes.helpContentGridItem} ${classes.helpContentGridItemBorder}`}
              >
                <Box className={classes.personGrid}>
                  {saltusownerinfo && saltusownerinfo.Image && (
                    <Box
                      className={`${classes.imageBox} "GridItemContentCenter"`}
                    >
                      <svg
                        viewBox="0 0 100 100"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="50" cy="50" r="50" />
                      </svg>
                      <img
                        className={classes.image}
                        src={saltusownerinfo.Image}
                        alt={saltusownerinfo.Title}
                      />
                    </Box>
                  )}
                  <Box className={`${classes.content} "GridItemContentCenter"`}>
                    {saltusownerinfo && (
                      <Typography className={classes.name} variant="body2">
                        {saltusownerinfo.Title}
                      </Typography>
                    )}
                    {saltusowner && saltusowner.PrimaryEmail && (
                      <Typography
                        variant="body2"
                        className={`${classes.emailLink} ${
                          saltusownerinfo && saltusownerinfo.Image
                            ? ''
                            : 'GridItemContentCenter'
                        }`}
                      >
                        <EmailIcon />
                        <a
                          target="_blank"
                          rel="nofollow noreferrer noopener"
                          href={`mailto:${saltusowner.PrimaryEmail}`}
                        >
                          {saltusowner.PrimaryEmail}
                        </a>
                      </Typography>
                    )}
                    {saltusowner && saltusowner.MobilePhone && (
                      <Typography
                        variant="body2"
                        className={`${classes.emailLink} ${
                          saltusownerinfo && saltusownerinfo.Image
                            ? ''
                            : 'GridItemContentCenter'
                        }`}
                      >
                        <span className={`${classes.contactNum} tel`}>
                          <MobileIcon className={classes.mobilePhone} />
                          <a
                            target="_blank"
                            rel="nofollow noreferrer noopener"
                            href={`tel:${saltusowner.MobilePhone}`}
                          >
                            {saltusowner.MobilePhone}
                          </a>
                        </span>
                      </Typography>
                    )}
                    {saltusowner && saltusowner.WorkPhone && (
                      <Typography
                        variant="body2"
                        className={`${classes.emailLink} ${
                          saltusownerinfo && saltusownerinfo.Image
                            ? ''
                            : 'GridItemContentCenter'
                        }`}
                      >
                        <span className={`${classes.contactNum} tel`}>
                          <PhoneIcon className={classes.workPhone} />
                          <a
                            target="_blank"
                            rel="nofollow noreferrer noopener"
                            href={`tel:${saltusowner.WorkPhone}`}
                          >
                            {saltusowner.WorkPhone}
                          </a>
                        </span>
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Box>

              <Box
                className={classes.helpContentGridItem}
                style={{ textAlign: 'center' }}
              >
                <Button className={classes.button} variant="outlined" fullWidth>
                  <a
                    target="_blank"
                    rel="nofollow noreferrer noopener"
                    href={`mailto:${saltusowner.PrimaryEmail}`}
                  >
                    Book an appointment
                  </a>
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default withStyles(styles)(HelpCard);
